import React, { FC } from 'react';

export const InfoIcon: FC = () => (
  <svg width="24" height="24" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" fill="none">
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M3 12.0002C3 7.02924 7.029 3.00024 12 3.00024C16.971 3.00024 21 7.02924 21 12.0002C21 16.9712 16.971 21.0002 12 21.0002C7.029 21.0002 3 16.9712 3 12.0002ZM13 10.0002V15.0002L14 16.0002V17.0002H10V16.0002L11 15.0002V12.0002H10L11 10.0002H13ZM13 7.00024V9.00024H11V7.00024H13Z"
      fill="currentColor"
    />
  </svg>
);
